// AudioContext.js
import React, { createContext, useState, useContext } from 'react';

const AudioDataContext = createContext();

export const AudioDataProvider = ({ children }) => {
  const [calibrationData, setCalibrationData] = useState({
    micModelName: '',
    micSensitivity: '',
    audioInterfaceModel: '',
    dutModelName: '',
    dutSplCriteria: '',
    osdVolumeSetting: '',
  });

  const [detectionResults, setDetectionResults] = useState([]);
  const [originalAudioFiles, setOriginalAudioFiles] = useState([]);
  const [humanJudgment, setHumanJudgment] = useState(null);
  const [hasBuzzDetected, setHasBuzzDetected] = useState(false);
// Add to provider value:



  return (
    <AudioDataContext.Provider value={{
      calibrationData,
      setCalibrationData,
      detectionResults,
      setDetectionResults,
      originalAudioFiles,
      setOriginalAudioFiles,
      humanJudgment,
      setHumanJudgment, 
      hasBuzzDetected,
    setHasBuzzDetected,
    }}>
      {children}
    </AudioDataContext.Provider>
  );
};

export const useAudioData = () => {
  const context = useContext(AudioDataContext);
  if (!context) {
    throw new Error('useAudioData must be used within AudioDataProvider');
  }
  return context;
};